import { Center, Paper, Stack, Text, Title, Button } from '@mantine/core';
import { IconShieldOff } from '@tabler/icons-react';
import { useNavigate } from 'react-router-dom';

export function AccessDenied(): JSX.Element {
  const navigate = useNavigate();

  return (
    <Center mih="60vh">
      <Paper p="xl" radius="md" withBorder maw={440} w="100%">
        <Stack align="center" gap="md">
          <IconShieldOff size={48} stroke={1.5} style={{ color: 'var(--mantine-color-red-6)' }} />
          <Title order={3} ta="center">
            Access Denied
          </Title>
          <Text size="sm" c="dimmed" ta="center">
            You do not have permission to view this page. If you believe this is an error, contact
            your administrator.
          </Text>
          <Button variant="light" onClick={() => navigate(-1)}>
            Go back
          </Button>
        </Stack>
      </Paper>
    </Center>
  );
}
